import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

export default function TestimonialSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="relative bg-foreground-950 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row">
            <div className="w-full lg:w-2/5 relative">
              <div className="lg:absolute lg:-left-8 lg:top-1/2 lg:-translate-y-1/2 lg:w-[120%]">
                <img
                  src="https://readdy.ai/api/search-image?query=Unboxing%20fashion%20items%20from%20package%20on%20cream%20background%2C%20warm%20soft%20lighting%2C%20lifestyle%20product%20photography%2C%20elevated%20editorial%20style%2C%20neutral%20earth%20tones%2C%20minimal%20aesthetic&width=600&height=700&seq=testimonial-img-01&orientation=portrait"
                  alt="YOYBUY unboxing experience"
                  className="w-full h-64 lg:h-[420px] object-cover rounded-2xl lg:rounded-r-none"
                  title="YOYBUY Finds покупки из Китая"
                />
              </div>
            </div>

            <div className="w-full lg:w-3/5 p-8 md:p-12 lg:pl-16 flex flex-col justify-center">
              <span className="text-6xl md:text-7xl text-primary-400 font-heading leading-none mb-4">&ldquo;</span>
              <p className="text-sm md:text-base text-background-50/90 leading-relaxed">
                {t('testimonial.text')}
              </p>
              <div className="mt-6">
                <p className="text-sm font-semibold text-background-50">{t('testimonial.name')}</p>
                <p className="text-xs text-background-50/50 mt-0.5">{t('testimonial.role')}</p>
              </div>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 mt-8 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-400 transition-all duration-300 whitespace-nowrap w-fit cursor-pointer"
              >
                {t('testimonial.cta')}
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-up-line text-sm"></i>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}